import { render, staticRenderFns } from "./NdtTable.vue?vue&type=template&id=74c9c207"
import script from "./NdtTable.vue?vue&type=script&lang=ts"
export * from "./NdtTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports